import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from 'vue'
import { useGrid } from 'vue-screen'


export default /*#__PURE__*/_defineComponent({
  __name: 'FixedBottomControls',
  emits: ["resize"],
  setup(__props, { emit: emits }) {


const grid = useGrid('tailwind')
const fixedBottom = ref<HTMLElement | undefined>()
const fixedBottomResize$ = new ResizeObserver((m) => emits('resize', m[0].borderBoxSize[0].blockSize))
onMounted(() => {
	if (fixedBottom.value && !grid.breakpoint) fixedBottomResize$.observe(fixedBottom.value)
})
onUnmounted(() => fixedBottomResize$.disconnect())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "fixedBottom",
    ref: fixedBottom,
    class: _normalizeClass(["w-full", { 'fixed-bottom': !_unref(grid).breakpoint }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})